import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";

const StarRating = ({ number }) => {
	const count = number ?? 0;
	return <Rating style={{ maxWidth: 150 }} value={count} readOnly />;
};

export default StarRating;
